import Head from 'expo-router/head';
import { useState } from 'react';
import { ScrollView } from 'react-native';
import { getTokenValue, YStack } from 'tamagui';

import PSButton from '@/components/ui/PSButton';
import PSModal from '@/components/ui/PSModal';
import PSText from '@/components/ui/PSText';

/**
 * ── /components/ps-modal ─────────────────────────────────────────────────
 *
 * A modal can't be drawn inline, so each state is a button that opens it. In
 * the app the CTA navigates away; here it just closes the preview.
 * ─────────────────────────────────────────────────────────────────────────
 */

const STATES = [
  {
    id: 'trial-ineligible',
    label: "Trial Pass to an ex-member — the confirm screen's real copy",
    title: "Trial Pass isn't available",
    message:
      "Trial Pass is only for first-time members, and you've been a member before.",
    ctaTitle: 'Go to home',
  },
  {
    id: 'long-copy',
    label: 'Long title + long reason — wraps, card grows',
    title: 'This membership can’t be purchased right now, for a reason',
    message:
      "We're still confirming a membership you've already bought. It'll show up on its own once the payment goes through — there's no need to pay again, and paying twice would only switch you between plans.",
    ctaTitle: 'Go to home',
  },
];

export default function PSModalPreview() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <>
      <Head>
        <title>PSModal · Putting Scene</title>
      </Head>
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: getTokenValue('$color.background', 'color'),
        }}
      >
        <YStack items="flex-start" gap="$lg" p="$lg">
          {STATES.map((state) => (
            <YStack key={state.id} gap="$xs">
              <PSText.Body3 color="$color.textDarkMuted">
                {state.label}
              </PSText.Body3>
              <PSButton title="Open" onPress={() => setOpenId(state.id)} />
              <PSModal
                visible={openId === state.id}
                title={state.title}
                message={state.message}
                ctaTitle={state.ctaTitle}
                onPressCta={() => setOpenId(null)}
              />
            </YStack>
          ))}
        </YStack>
      </ScrollView>
    </>
  );
}
